<template lang="pug">
  .div
    .columns
      .column.is-3
        .field
          label.label Póliza
            .control
              .select.is-primary
                select(v-model="polizaSel" :disabled="isDisabled")
                  option(v-for="p in polizas" :key="p.id" :value="p") {{ p.poliza }}
      .column.is-3
        .field
          label.label Estatus
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='Estatus..',
                v-model="status",
                :disabled="isDisabled"
              )
      .column.is-3
        .field
          label.label Aseguradora
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='Aseguradora..',
                v-model="aseguradora",
                :disabled="isDisabled"
              )
      .column.is-3
        .field
          label.label Cobertura
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='Cobertura..',
                v-model="cobertura",
                :disabled="isDisabled"
              )
    .columns
      .column.is-6
        .field
          label.label Observaciones
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='Observaciones..',
                v-model="observaciones",
                :disabled="isDisabled"
              )
      .column.is-4
        | Vencimiento de la Póliza:
        .field
          .control
            flat-pickr(
              v-model='fechaVencimiento'
              :config="config"
              class="input",
              :disabled="isDisabled"
            )
    .columns
      .column.is-3
        .field
          label Hojalatería
          input#item1B.is-checkradio.is-primary(type='checkbox', v-model='hojalateria.BE' :disabled="isDisabled")
          label.is-size-6(for='item1B') BE
          input#item1R.is-checkradio.is-primary(type='checkbox', v-model='hojalateria.RE' :disabled="isDisabled")
          label.is-size-6(for='item1R') RE
      .column.is-3
        .field
          label Emblema Tras.
          input#item14B.is-checkradio.is-primary(type='checkbox', v-model='emblemaT.BE' :disabled="isDisabled")
          label.is-size-6(for='item14B') BE
          input#item14R.is-checkradio.is-primary(type='checkbox', v-model='emblemaT.RE' :disabled="isDisabled")
          label.is-size-6(for='item14R') RE
      .column.is-3
        .field
          label Tapón de Rines
          input#item27B.is-checkradio.is-primary(type='checkbox', v-model='taponRueda.BE' :disabled="isDisabled")
          label.is-size-6(for='item27B') BE
          input#item27R.is-checkradio.is-primary(type='checkbox', v-model='taponRueda.RE' :disabled="isDisabled")
          label.is-size-6(for='item27R') RE
      .column.is-3
        .field
          label Llave
          input#item40B.is-checkradio.is-primary(type='checkbox', v-model='llave.BE' :disabled="isDisabled")
          label.is-size-6(for='item40B') BE
          input#item40R.is-checkradio.is-primary(type='checkbox', v-model='llave.RE' :disabled="isDisabled")
          label.is-size-6(for='item40R') RE
    .columns
      .column.is-3
        .field
          label Pintura
          input#item2B.is-checkradio.is-primary(type='checkbox', v-model='pintura.BE' :disabled="isDisabled")
          label.is-size-6(for='item2B') BE
          input#item2R.is-checkradio.is-primary(type='checkbox', v-model='pintura.RE' :disabled="isDisabled")
          label.is-size-6(for='item2R') RE
      .column.is-3
        .field
          label Defensas
          input#item15B.is-checkradio.is-primary(type='checkbox', v-model='defensas.BE' :disabled="isDisabled")
          label.is-size-6(for='item15B') BE
          input#item15R.is-checkradio.is-primary(type='checkbox', v-model='defensas.RE' :disabled="isDisabled")
          label.is-size-6(for='item15R') RE
      .column.is-3
        .field
          label Birlos de Seguridad
          input#item28B.is-checkradio.is-primary(type='checkbox', v-model='birlos.BE' :disabled="isDisabled")
          label.is-size-6(for='item28B') BE
          input#item28R.is-checkradio.is-primary(type='checkbox', v-model='birlos.RE' :disabled="isDisabled")
          label.is-size-6(for='item28R') RE
      .column.is-3
        .field
          label Reflejantes
          input#item41B.is-checkradio.is-primary(type='checkbox', v-model='reflejantes.BE' :disabled="isDisabled")
          label.is-size-6(for='item41B') BE
          input#item41R.is-checkradio.is-primary(type='checkbox', v-model='reflejantes.RE' :disabled="isDisabled")
          label.is-size-6(for='item41R') RE
    .columns
      .column.is-3
        .field
          label Motor
          input#item3B.is-checkradio.is-primary(type='checkbox', v-model='motor.BE' :disabled="isDisabled")
          label.is-size-6(for='item3B') BE
          input#item3R.is-checkradio.is-primary(type='checkbox', v-model='motor.RE' :disabled="isDisabled")
          label.is-size-6(for='item3R') RE
      .column.is-3
        .field
          label Molduras
          input#item16B.is-checkradio.is-primary(type='checkbox', v-model='molduras.BE' :disabled="isDisabled")
          label.is-size-6(for='item16B') BE
          input#item16R.is-checkradio.is-primary(type='checkbox', v-model='molduras.RE' :disabled="isDisabled")
          label.is-size-6(for='item16R') RE
      .column.is-3
        .field
          label Vestiduras
          input#item29B.is-checkradio.is-primary(type='checkbox', v-model='vestiduras.BE' :disabled="isDisabled")
          label.is-size-6(for='item29B') BE
          input#item29R.is-checkradio.is-primary(type='checkbox', v-model='vestiduras.RE' :disabled="isDisabled")
          label.is-size-6(for='item29R') RE
      .column.is-3
        .field
          label Llave Cruz
          input#item42B.is-checkradio.is-primary(type='checkbox', v-model='llaveCruz.BE' :disabled="isDisabled")
          label.is-size-6(for='item42B') BE
          input#item42R.is-checkradio.is-primary(type='checkbox', v-model='llaveCruz.RE' :disabled="isDisabled")
          label.is-size-6(for='item42R') RE
    .columns
      .column.is-3
        .field
          label Varilla Aceite
          input#item4B.is-checkradio.is-primary(type='checkbox', v-model='varillaAceite.BE' :disabled="isDisabled")
          label.is-size-6(for='item4B') BE
          input#item4R.is-checkradio.is-primary(type='checkbox', v-model='varillaAceite.RE' :disabled="isDisabled")
          label.is-size-6(for='item4R') RE
      .column.is-3
        .field
          label Espejo Lat. D.
          input#item17B.is-checkradio.is-primary(type='checkbox', v-model='espejoLD.BE' :disabled="isDisabled")
          label.is-size-6(for='item17B') BE
          input#item17R.is-checkradio.is-primary(type='checkbox', v-model='espejoLD.RE' :disabled="isDisabled")
          label.is-size-6(for='item17R') RE
      .column.is-3
        .field
          label Cinturones de Seg.
          input#item30B.is-checkradio.is-primary(type='checkbox', v-model='cinturonesSeg.BE' :disabled="isDisabled")
          label.is-size-6(for='item30B') BE
          input#item30R.is-checkradio.is-primary(type='checkbox', v-model='cinturonesSeg.RE' :disabled="isDisabled")
          label.is-size-6(for='item30R') RE
      .column.is-3
        .field
          label Cable Pasa Corr.
          input#item43B.is-checkradio.is-primary(type='checkbox', v-model='cablesCor.BE' :disabled="isDisabled")
          label.is-size-6(for='item43B') BE
          input#item43R.is-checkradio.is-primary(type='checkbox', v-model='cablesCor.RE' :disabled="isDisabled")
          label.is-size-6(for='item43R') RE
    .columns
      .column.is-3
        .field
          label Tapón Aceite
          input#item5B.is-checkradio.is-primary(type='checkbox', v-model='taponAceite.BE' :disabled="isDisabled")
          label.is-size-6(for='item5B') BE
          input#item5R.is-checkradio.is-primary(type='checkbox', v-model='taponAceite.RE' :disabled="isDisabled")
          label.is-size-6(for='item5R') RE
      .column.is-3
        .field
          label Espejo Lat. I.
          input#item18B.is-checkradio.is-primary(type='checkbox', v-model='espejoLI.BE' :disabled="isDisabled")
          label.is-size-6(for='item18B') BE
          input#item18R.is-checkradio.is-primary(type='checkbox', v-model='espejoLI.RE' :disabled="isDisabled")
          label.is-size-6(for='item18R') RE
      .column.is-3
        .field
          label Viceras Parasol
          input#item31B.is-checkradio.is-primary(type='checkbox', v-model='viceras.BE' :disabled="isDisabled")
          label.is-size-6(for='item31B') BE
          input#item31R.is-checkradio.is-primary(type='checkbox', v-model='viceras.RE' :disabled="isDisabled")
          label.is-size-6(for='item31R') RE
      .column.is-3
        .field
          label Extintor
          input#item44B.is-checkradio.is-primary(type='checkbox', v-model='extintor.BE' :disabled="isDisabled")
          label.is-size-6(for='item44B') BE
          input#item44R.is-checkradio.is-primary(type='checkbox', v-model='extintor.RE' :disabled="isDisabled")
          label.is-size-6(for='item44R') RE
    .columns
      .column.is-3
        .field
          label Tapón Radiador
          input#item6B.is-checkradio.is-primary(type='checkbox', v-model='taponRadiador.BE' :disabled="isDisabled")
          label.is-size-6(for='item6B') BE
          input#item6R.is-checkradio.is-primary(type='checkbox', v-model='taponRadiador.RE' :disabled="isDisabled")
          label.is-size-6(for='item6R') RE
      .column.is-3
        .field
          label Manijas Puertas
          input#item19B.is-checkradio.is-primary(type='checkbox', v-model='manija.BE' :disabled="isDisabled")
          label.is-size-6(for='item19B') BE
          input#item19R.is-checkradio.is-primary(type='checkbox', v-model='manija.RE' :disabled="isDisabled")
          label.is-size-6(for='item19R') RE
      .column.is-3
        .field
          label Espejo Int.
          input#item32B.is-checkradio.is-primary(type='checkbox', v-model='espejoInt.BE' :disabled="isDisabled")
          label.is-size-6(for='item32B') BE
          input#item32R.is-checkradio.is-primary(type='checkbox', v-model='espejoInt.RE' :disabled="isDisabled")
          label.is-size-6(for='item32R') RE
      .column.is-3
        .field
          label Manual
          input#item45B.is-checkradio.is-primary(type='checkbox', v-model='manual.BE' :disabled="isDisabled")
          label.is-size-6(for='item45B') BE
          input#item45R.is-checkradio.is-primary(type='checkbox', v-model='manual.RE' :disabled="isDisabled")
          label.is-size-6(for='item45R') RE
    .columns
      .column.is-3
        .field
          label Placa Del.
          input#item7B.is-checkradio.is-primary(type='checkbox', v-model='placaD.BE' :disabled="isDisabled")
          label.is-size-6(for='item7B') BE
          input#item7R.is-checkradio.is-primary(type='checkbox', v-model='placaD.RE' :disabled="isDisabled")
          label.is-size-6(for='item7R') RE
      .column.is-3
        .field
          label Tapón Gasolina
          input#item20B.is-checkradio.is-primary(type='checkbox', v-model='taponGas.BE' :disabled="isDisabled")
          label.is-size-6(for='item20B') BE
          input#item20R.is-checkradio.is-primary(type='checkbox', v-model='taponGas.RE' :disabled="isDisabled")
          label.is-size-6(for='item20R') RE
      .column.is-3
        .field
          label Radio Estéreo
          input#item33B.is-checkradio.is-primary(type='checkbox', v-model='radio.BE' :disabled="isDisabled")
          label.is-size-6(for='item33B') BE
          input#item33R.is-checkradio.is-primary(type='checkbox', v-model='radio.RE' :disabled="isDisabled")
          label.is-size-6(for='item33R') RE
      .column.is-3
        .field
          label Tarjeta Circ.
          input#item46B.is-checkradio.is-primary(type='checkbox', v-model='tarjetaCirc.BE' :disabled="isDisabled")
          label.is-size-6(for='item46B') BE
          input#item46R.is-checkradio.is-primary(type='checkbox', v-model='tarjetaCirc.RE' :disabled="isDisabled")
          label.is-size-6(for='item46R') RE
    .columns
      .column.is-3
        .field
          label Placa Tras.
          input#item8B.is-checkradio.is-primary(type='checkbox', v-model='placaT.BE' :disabled="isDisabled")
          label.is-size-6(for='item8B') BE
          input#item8R.is-checkradio.is-primary(type='checkbox', v-model='placaT.RE' :disabled="isDisabled")
          label.is-size-6(for='item8R') RE
      .column.is-3
        .field
          label Limpia Parabrisas
          input#item21B.is-checkradio.is-primary(type='checkbox', v-model='limpiadores.BE' :disabled="isDisabled")
          label.is-size-6(for='item21B') BE
          input#item21R.is-checkradio.is-primary(type='checkbox', v-model='limpiadores.RE' :disabled="isDisabled")
          label.is-size-6(for='item21R') RE
      .column.is-3
        .field
          label Tapetes
          input#item34B.is-checkradio.is-primary(type='checkbox', v-model='tapetes.BE' :disabled="isDisabled")
          label.is-size-6(for='item34B') BE
          input#item34R.is-checkradio.is-primary(type='checkbox', v-model='tapetes.RE' :disabled="isDisabled")
          label.is-size-6(for='item34R') RE
      .column.is-3
        .field
          label Verificación V.
          input#item47B.is-checkradio.is-primary(type='checkbox', v-model='verificacion.BE' :disabled="isDisabled")
          label.is-size-6(for='item47B') BE
          input#item47R.is-checkradio.is-primary(type='checkbox', v-model='verificacion.RE' :disabled="isDisabled")
          label.is-size-6(for='item47R') RE
    .columns
      .column.is-3
        .field
          label Porta Placa Del.
          input#item9B.is-checkradio.is-primary(type='checkbox', v-model='portaPD.BE' :disabled="isDisabled")
          label.is-size-6(for='item9B') BE
          input#item9R.is-checkradio.is-primary(type='checkbox', v-model='portaPD.RE' :disabled="isDisabled")
          label.is-size-6(for='item9R') RE
      .column.is-3
        .field
          label Parabrisas
          input#item22B.is-checkradio.is-primary(type='checkbox', v-model='parabrisas.BE' :disabled="isDisabled")
          label.is-size-6(for='item22B') BE
          input#item22R.is-checkradio.is-primary(type='checkbox', v-model='parabrisas.RE' :disabled="isDisabled")
          label.is-size-6(for='item22R') RE
      .column.is-3
        .field
          label Encendedor
          input#item35B.is-checkradio.is-primary(type='checkbox', v-model='encendedor.BE' :disabled="isDisabled")
          label.is-size-6(for='item35B') BE
          input#item35R.is-checkradio.is-primary(type='checkbox', v-model='encendedor.RE' :disabled="isDisabled")
          label.is-size-6(for='item35R') RE
      .column.is-3
        .field
          label Póliza Vigente
          input#item48B.is-checkradio.is-primary(type='checkbox', v-model='polizaV.BE' :disabled="isDisabled")
          label.is-size-6(for='item48B') BE
          input#item48R.is-checkradio.is-primary(type='checkbox', v-model='polizaV.RE' :disabled="isDisabled")
          label.is-size-6(for='item48R') RE
    .columns
      .column.is-3
        .field
          label Porta Placa Tras.
          input#item10B.is-checkradio.is-primary(type='checkbox', v-model='portaPT.BE' :disabled="isDisabled")
          label.is-size-6(for='item10B') BE
          input#item10R.is-checkradio.is-primary(type='checkbox', v-model='portaPT.RE' :disabled="isDisabled")
          label.is-size-6(for='item10R') RE
      .column.is-3
        .field
          label Cristales Laterales
          input#item23B.is-checkradio.is-primary(type='checkbox', v-model='cristales.BE' :disabled="isDisabled")
          label.is-size-6(for='item23B') BE
          input#item23R.is-checkradio.is-primary(type='checkbox', v-model='cristales.RE' :disabled="isDisabled")
          label.is-size-6(for='item23R') RE
      .column.is-3
        .field
          label Antena Radio
          input#item36B.is-checkradio.is-primary(type='checkbox', v-model='antenaRadio.BE' :disabled="isDisabled")
          label.is-size-6(for='item36B') BE
          input#item36R.is-checkradio.is-primary(type='checkbox', v-model='antenaRadio.RE' :disabled="isDisabled")
          label.is-size-6(for='item36R') RE
      .column.is-3
        .field
          label Batea
          input#item49B.is-checkradio.is-primary(type='checkbox', v-model='batea.BE' :disabled="isDisabled")
          label.is-size-6(for='item49B') BE
          input#item49R.is-checkradio.is-primary(type='checkbox', v-model='batea.RE' :disabled="isDisabled")
          label.is-size-6(for='item49R') RE
    .columns
      .column.is-3
        .field
          label Faros
          input#item11B.is-checkradio.is-primary(type='checkbox', v-model='faros.BE' :disabled="isDisabled")
          label.is-size-6(for='item11B') BE
          input#item11R.is-checkradio.is-primary(type='checkbox', v-model='faros.RE' :disabled="isDisabled")
          label.is-size-6(for='item11R') RE
      .column.is-3
        .field
          label Medallón
          input#item24B.is-checkradio.is-primary(type='checkbox', v-model='medallon.BE' :disabled="isDisabled")
          label.is-size-6(for='item24B') BE
          input#item24R.is-checkradio.is-primary(type='checkbox', v-model='medallon.RE' :disabled="isDisabled")
          label.is-size-6(for='item24R') RE
      .column.is-3
        .field
          label Llanta de Refacción
          input#item37B.is-checkradio.is-primary(type='checkbox', v-model='llanta.BE' :disabled="isDisabled")
          label.is-size-6(for='item37B') BE
          input#item37R.is-checkradio.is-primary(type='checkbox', v-model='llanta.RE' :disabled="isDisabled")
          label.is-size-6(for='item37R') RE
      .column.is-3
        .field
          label Llave Tapón Comb.
          input#item50B.is-checkradio.is-primary(type='checkbox', v-model='llaveTaponComb.BE' :disabled="isDisabled")
          label.is-size-6(for='item50B') BE
          input#item50R.is-checkradio.is-primary(type='checkbox', v-model='llaveTaponComb.RE' :disabled="isDisabled")
          label.is-size-6(for='item50R') RE
    .columns
      .column.is-3
        .field
          label Emblema Del.
          input#item13B.is-checkradio.is-primary(type='checkbox', v-model='emblemaD.BE' :disabled="isDisabled")
          label.is-size-6(for='item13B') BE
          input#item13R.is-checkradio.is-primary(type='checkbox', v-model='emblemaD.RE' :disabled="isDisabled")
          label.is-size-6(for='item13R') RE
      .column.is-3
        .field
          label Llantas
          input#item25B.is-checkradio.is-primary(type='checkbox', v-model='llantas.BE' :disabled="isDisabled")
          label.is-size-6(for='item25B') BE
          input#item25R.is-checkradio.is-primary(type='checkbox', v-model='llantas.RE' :disabled="isDisabled")
          label.is-size-6(for='item25R') RE
      .column.is-3
        .field
          label Bolsa Herramienta
          input#item38B.is-checkradio.is-primary(type='checkbox', v-model='bolsa.BE' :disabled="isDisabled")
          label.is-size-6(for='item38B') BE
          input#item38R.is-checkradio.is-primary(type='checkbox', v-model='bolsa.RE' :disabled="isDisabled")
          label.is-size-6(for='item38R') RE
      .column.is-3
        .field
          label Llave C. Arranque
          input#item51B.is-checkradio.is-primary(type='checkbox', v-model='controlApert.BE' :disabled="isDisabled")
          label.is-size-6(for='item51B') BE
          input#item51R.is-checkradio.is-primary(type='checkbox', v-model='controlApert.RE' :disabled="isDisabled")
          label.is-size-6(for='item51R') RE
    .columns
      .column.is-3
        .field
          label Calaveras
          input#item12B.is-checkradio.is-primary(type='checkbox', v-model='calaveras.BE' :disabled="isDisabled")
          label.is-size-6(for='item12B') BE
          input#item12R.is-checkradio.is-primary(type='checkbox', v-model='calaveras.RE' :disabled="isDisabled")
          label.is-size-6(for='item12R') RE  
      .column.is-3
        .field
          label Rines
          input#item26B.is-checkradio.is-primary(type='checkbox', v-model='rines.BE' :disabled="isDisabled")
          label.is-size-6(for='item26B') BE
          input#item26R.is-checkradio.is-primary(type='checkbox', v-model='rines.RE' :disabled="isDisabled")
          label.is-size-6(for='item26R') RE
      .column.is-3
        .field
          label Gato
          input#item39B.is-checkradio.is-primary(type='checkbox', v-model='gato.BE' :disabled="isDisabled")
          label.is-size-6(for='item39B') BE
          input#item39R.is-checkradio.is-primary(type='checkbox', v-model='gato.RE' :disabled="isDisabled")
          label.is-size-6(for='item39R') RE
      .column.is-3
        .field
          label Bedliner
          input#item52B.is-checkradio.is-primary(type='checkbox', v-model='bedliner.BE' :disabled="isDisabled")
          label.is-size-6(for='item52B') BE
          input#item52R.is-checkradio.is-primary(type='checkbox', v-model='bedliner.RE' :disabled="isDisabled")
          label.is-size-6(for='item52R') RE
    .colums
      .column.is-3
        .field
          label Tapa CubreBatea
          input#item53B.is-checkradio.is-primary(type='checkbox', v-model='tapaCBatea.BE' :disabled="isDisabled")
          label.is-size-6(for='item53B') BE
          input#item53R.is-checkradio.is-primary(type='checkbox', v-model='tapaCBatea.RE' :disabled="isDisabled")
          label.is-size-6(for='item53R') RE
    .columns
      .column.is-offset-3.is-3
        a.button.is-block(@click="cancelAdd")
          | Cancelar 
      .column.is-3
        a.button.is-black.is-block(@click="saveItems" :disabled="isDisabled")
          | Guardar Items para Inventario
</template>

<script>
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import moment from 'moment'

  export default {
    name: 'ListItems_Vehiculo',
    components: { flatPickr },
    props: {
      desHabilitar: {
        type: Boolean,
        default: false
      },
      articulo: {
        type: Object,
        default: () => {}  
      },
      polizas: {
        type: Array,
        default: [],
      }
    },
    data() {
      return {
        status: 'ACTIVA',
        aseguradora: '',
        poliza: null,
        cobertura: '',
        antenaRadio: {
          RE: false,
          BE: false,
        },
        batea: {
          RE: false,
          BE: false,
        },
        bedliner: {
          RE: false,
          BE: false,
        },
        birlos: {
          RE: false,
          BE: false,
        },
        bolsa: {
          RE: false,
          BE: false,
        },
        cablesCor: {
          RE: false,
          BE: false,
        },
        calaveras: {
          RE: false,
          BE: false,
        },
        cinturonesSeg: {
          RE: false,
          BE: false,
        },
        controlApert: {
          RE: false,
          BE: false,
        },
        cristales: {
          RE: false,
          BE: false,
        },
        defensas: {
          RE: false,
          BE: false,
        },
        emblemaD: {
          RE: false,
          BE: false,
        },
        emblemaT: {
          RE: false,
          BE: false,
        },
        encendedor: {
          RE: false,
          BE: false,
        },
        espejoInt: {
          RE: false,
          BE: false,
        },
        espejoLD: {
          RE: false,
          BE: false,
        },
        espejoLI: {
          RE: false,
          BE: false,
        },
        extintor: {
          RE: false,
          BE: false,
        },
        faros: {
          RE: false,
          BE: false,
        },
        hojalateria: {
          RE: false,
          BE: false,
        },
        gato: {
          RE: false,
          BE: false,
        },
        limpiadores: {
          RE: false,
          BE: false,
        },
        llanta: {
          RE: false,
          BE: false,
        },
        llantas: {
          RE: false,
          BE: false,
        },
        llave: {
          RE: false,
          BE: false,
        },
        llaveCruz: {
          RE: false,
          BE: false,
        },
        llaveTaponComb: {
          RE: false,
          BE: false,
        },
        manija: {
          RE: false,
          BE: false,
        },
        manual: {
          RE: false,
          BE: false,
        },
        medallon: {
          RE: false,
          BE: false,
        },
        molduras: {
          RE: false,
          BE: false,
        },
        motor: {
          RE: false,
          BE: false,
        },
        parabrisas: {
          RE: false,
          BE: false,
        },
        pintura: {
          RE: false,
          BE: false,
        },
        placaD: {
          RE: false,
          BE: false,
        },
        placaT: {
          RE: false,
          BE: false,
        },
        polizaV: {
          RE: false,
          BE: false,
        },
        portaPD: {
          RE: false,
          BE: false,
        },
        portaPT: {
          RE: false,
          BE: false,
        },
        radio: {
          RE: false,
          BE: false,
        },
        reflejantes: {
          RE: false,
          BE: false,
        },
        rines: {
          RE: false,
          BE: false,
        },
        tapaCBatea: {
          RE: false,
          BE: false,
        },
        tapetes: {
          RE: false,
          BE: false,
        },
        taponAceite: {
          RE: false,
          BE: false,
        },
        taponRueda: {
          RE: false,
          BE: false,
        },
        taponGas: {
          RE: false,
          BE: false,
        },
        taponRadiador: {
          RE: false,
          BE: false,
        },
        tarjetaCirc: {
          RE: false,
          BE: false,
        },
        varillaAceite: {
          RE: false,
          BE: false,
        },
        verificacion: {
          RE: false,
          BE: false,
        },
        vestiduras: {
          RE: false,
          BE: false,
        },
        viceras: {
          RE: false,
          BE: false,
        },
        observaciones: null,
        itemsSelected: {},
        isDisabled: false,
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only          
        },
        fechaVencimiento: '',
        polizaSel: {},
      }
    },
    watch: {
      desHabilitar() {
        console.log(`DesHabilitar Items_Vehiculo: ${this.desHabilitar}`)
        if (this.desHabilitar) {
          console.log('deshabiliatr true')
          this.isDisabled = true
        } else {
          console.log('deshabiliatr false')
          this.isDisabled = false
        }
      },
      articulo() { 
        if (Object.keys(this.articulo).length > 0) {
          this.polizaSel = this.polizas.find( p => p.id == this.articulo.id_poliza)
        }
      },
      polizaSel () {
        this.aseguradora = this.polizaSel.aseguradora
        this.poliza = this.polizaSel.poliza
        this.fechaVencimiento = this.polizaSel.vigencia
        this.cobertura = this.polizaSel.coberturaStr
      },
      'antenaRadio.RE'() {
        if (this.antenaRadio.RE) {
          this.antenaRadio.BE = false
        }
      },
      'antenaRadio.BE'() {
        if (this.antenaRadio.BE) {
          this.antenaRadio.RE = false
        }
      },
      'batea.RE'() {
        if (this.batea.RE) {
          this.batea.BE = false
        }
      },
      'batea.BE'() {
        if (this.batea.BE) {
          this.batea.RE = false
        }
      },
      'bedliner.RE'() {
        if (this.bedliner.RE) {
          this.bedliner.BE = false
        }
      },
      'bedliner.BE'() {
        if (this.bedliner.BE) {
          this.bedliner.RE = false
        }
      },
      'birlos.RE'() {
        if (this.birlos.RE) {
          this.birlos.BE = false
        }
      },
      'birlos.BE'() {
        if (this.birlos.BE) {
          this.birlos.RE = false
        }
      },
      'bolsa.RE'() {
        if (this.bolsa.RE) {
          this.bolsa.BE = false
        }
      },
      'bolsa.BE'() {
        if (this.bolsa.BE) {
          this.bolsa.RE = false
        }
      },
      'cablesCor.RE'() {
        if (this.cablesCor.RE) {
          this.cablesCor.BE = false
        }
      },
      'cablesCor.BE'() {
        if (this.cablesCor.BE) {
          this.cablesCor.RE = false
        }
      },
      'calaveras.RE'() {
        if (this.calaveras.RE) {
          this.calaveras.BE = false
        }
      },
      'calaveras.BE'() {
        if (this.calaveras.BE) {
          this.calaveras.RE = false
        }
      },
      'cinturonesSeg.RE'() {
        if (this.cinturonesSeg.RE) {
          this.cinturonesSeg.BE = false
        }
      },
      'cinturonesSeg.BE'() {
        if (this.cinturonesSeg.BE) {
          this.cinturonesSeg.RE = false
        }
      },
      'controlApert.RE'() {
        if (this.controlApert.RE) {
          this.controlApert.BE = false
        }
      },
      'controlApert.BE'() {
        if (this.controlApert.BE) {
          this.controlApert.RE = false
        }
      },
      'cristales.RE'() {
        if (this.cristales.RE) {
          this.cristales.BE = false
        }
      },
      'cristales.BE'() {
        if (this.cristales.BE) {
          this.cristales.RE = false
        }
      },
      'defensas.RE'() {
        if (this.defensas.RE) {
          this.defensas.BE = false
        }
      },
      'defensas.BE'() {
        if (this.defensas.BE) {
          this.defensas.RE = false
        }
      },
      'emblemaD.RE'() {
        if (this.emblemaD.RE) {
          this.emblemaD.BE = false
        }
      },
      'emblemaD.BE'() {
        if (this.emblemaD.BE) {
          this.emblemaD.RE = false
        }
      },
      'emblemaT.RE'() {
        if (this.emblemaT.RE) {
          this.emblemaT.BE = false
        }
      },
      'emblemaT.BE'() {
        if (this.emblemaT.BE) {
          this.emblemaT.RE = false
        }
      },
      'encendedor.RE'() {
        if (this.encendedor.RE) {
          this.encendedor.BE = false
        }
      },
      'encendedor.BE'() {
        if (this.encendedor.BE) {
          this.encendedor.RE = false
        }
      },
      'espejoInt.RE'() {
        if (this.espejoInt.RE) {
          this.espejoInt.BE = false
        }
      },
      'espejoInt.BE'() {
        if (this.espejoInt.BE) {
          this.espejoInt.RE = false
        }
      },
      'espejoLD.RE'() {
        if (this.espejoLD.RE) {
          this.espejoLD.BE = false
        }
      },
      'espejoLD.BE'() {
        if (this.espejoLD.BE) {
          this.espejoLD.RE = false
        }
      },
      'espejoLI.RE'() {
        if (this.espejoLI.RE) {
          this.espejoLI.BE = false
        }
      },
      'espejoLI.BE'() {
        if (this.espejoLI.BE) {
          this.espejoLI.RE = false
        }
      },
      'extintor.RE'() {
        if (this.extintor.RE) {
          this.extintor.BE = false
        }
      },
      'extintor.BE'() {
        if (this.extintor.BE) {
          this.extintor.RE = false
        }
      },
      'faros.RE'() {
        if (this.faros.RE) {
          this.faros.BE = false
        }
      },
      'faros.BE'() {
        if (this.faros.BE) {
          this.faros.RE = false
        }
      },
      'hojalateria.RE'() {
        if (this.hojalateria.RE) {
          this.hojalateria.BE = false
        }
      },
      'hojalateria.BE'() {
        if (this.hojalateria.BE) {
          this.hojalateria.RE = false
        }
      },
      'gato.RE'() {
        if (this.gato.RE) {
          this.gato.BE = false
        }
      },
      'gato.BE'() {
        if (this.gato.BE) {
          this.gato.RE = false
        }
      },
      'limpiadores.RE'() {
        if (this.limpiadores.RE) {
          this.limpiadores.BE = false
        }
      },
      'limpiadores.BE'() {
        if (this.limpiadores.BE) {
          this.limpiadores.RE = false
        }
      },
      'llanta.RE'() {
        if (this.llanta.RE) {
          this.llanta.BE = false
        }
      },
      'llanta.BE'() {
        if (this.llanta.BE) {
          this.llanta.RE = false
        }
      },
      'llantas.RE'() {
        if (this.llantas.RE) {
          this.llantas.BE = false
        }
      },
      'llantas.BE'() {
        if (this.llantas.BE) {
          this.llantas.RE = false
        }
      },
      'llave.RE'() {
        if (this.llave.RE) {
          this.llave.BE = false
        }
      },
      'llave.BE'() {
        if (this.llave.BE) {
          this.llave.RE = false
        }
      },
      'llaveCruz.RE'() {
        if (this.llaveCruz.RE) {
          this.llaveCruz.BE = false
        }
      },
      'llaveCruz.BE'() {
        if (this.llaveCruz.BE) {
          this.llaveCruz.RE = false
        }
      },
      'llaveTaponComb.RE'() {
        if (this.llaveTaponComb.RE) {
          this.llaveTaponComb.BE = false
        }
      },
      'llaveTaponComb.BE'() {
        if (this.llaveTaponComb.BE) {
          this.llaveTaponComb.RE = false
        }
      },
      'manija.RE'() {
        if (this.manija.RE) {
          this.manija.BE = false
        }
      },
      'manija.BE'() {
        if (this.manija.BE) {
          this.manija.RE = false
        }
      },
      'manual.RE'() {
        if (this.manual.RE) {
          this.manual.BE = false
        }
      },
      'manual.BE'() {
        if (this.manual.BE) {
          this.manual.RE = false
        }
      },
      'medallon.RE'() {
        if (this.medallon.RE) {
          this.medallon.BE = false
        }
      },
      'medallon.BE'() {
        if (this.medallon.BE) {
          this.medallon.RE = false
        }
      },
      'molduras.RE'() {
        if (this.molduras.RE) {
          this.molduras.BE = false
        }
      },
      'molduras.BE'() {
        if (this.molduras.BE) {
          this.molduras.RE = false
        }
      },
      'motor.RE'() {
        if (this.motor.RE) {
          this.motor.BE = false
        }
      },
      'motor.BE'() {
        if (this.motor.BE) {
          this.motor.RE = false
        }
      },
      'parabrisas.RE'() {
        if (this.parabrisas.RE) {
          this.parabrisas.BE = false
        }
      },
      'parabrisas.BE'() {
        if (this.parabrisas.BE) {
          this.parabrisas.RE = false
        }
      },
      'pintura.RE'() {
        if (this.pintura.RE) {
          this.pintura.BE = false
        }
      },
      'pintura.BE'() {
        if (this.pintura.BE) {
          this.pintura.RE = false
        }
      },
      'placaD.RE'() {
        if (this.placaD.RE) {
          this.placaD.BE = false
        }
      },
      'placaD.BE'() {
        if (this.placaD.BE) {
          this.placaD.RE = false
        }
      },
      'placaT.RE'() {
        if (this.placaT.RE) {
          this.placaT.BE = false
        }
      },
      'placaT.BE'() {
        if (this.placaT.BE) {
          this.placaT.RE = false
        }
      },
      'polizaV.RE'() {
        if (this.polizaV.RE) {
          this.polizaV.BE = false
        }
      },
      'polizaV.BE'() {
        if (this.polizaV.BE) {
          this.polizaV.RE = false
        }
      },
      'portaPD.RE'() {
        if (this.portaPD.RE) {
          this.portaPD.BE = false
        }
      },
      'portaPD.BE'() {
        if (this.portaPD.BE) {
          this.portaPD.RE = false
        }
      },
      'portaPT.RE'() {
        if (this.portaPT.RE) {
          this.portaPT.BE = false
        }
      },
      'portaPT.BE'() {
        if (this.portaPT.BE) {
          this.portaPT.RE = false
        }
      },
      'radio.RE'() {
        if (this.radio.RE) {
          this.radio.BE = false
        }
      },
      'radio.BE'() {
        if (this.radio.BE) {
          this.radio.RE = false
        }
      },
      'reflejantes.RE'() {
        if (this.reflejantes.RE) {
          this.reflejantes.BE = false
        }
      },
      'reflejantes.BE'() {
        if (this.reflejantes.BE) {
          this.reflejantes.RE = false
        }
      },
      'rines.RE'() {
        if (this.rines.RE) {
          this.rines.BE = false
        }
      },
      'rines.BE'() {
        if (this.rines.BE) {
          this.rines.RE = false
        }
      },
      'tapaCBatea.RE'() {
        if (this.tapaCBatea.RE) {
          this.tapaCBatea.BE = false
        }
      },
      'tapaCBatea.BE'() {
        if (this.tapaCBatea.BE) {
          this.tapaCBatea.RE = false
        }
      },
      'tapetes.RE'() {
        if (this.tapetes.RE) {
          this.tapetes.BE = false
        }
      },
      'tapetes.BE'() {
        if (this.tapetes.BE) {
          this.tapetes.RE = false
        }
      },
      'taponAceite.RE'() {
        if (this.taponAceite.RE) {
          this.taponAceite.BE = false
        }
      },
      'taponAceite.BE'() {
        if (this.taponAceite.BE) {
          this.taponAceite.RE = false
        }
      },
      'taponRueda.RE'() {
        if (this.taponRueda.RE) {
          this.taponRueda.BE = false
        }
      },
      'taponRueda.BE'() {
        if (this.taponRueda.BE) {
          this.taponRueda.RE = false
        }
      },
      'taponGas.RE'() {
        if (this.taponGas.RE) {
          this.taponGas.BE = false
        }
      },
      'taponGas.BE'() {
        if (this.taponGas.BE) {
          this.taponGas.RE = false
        }
      },
      'taponRadiador.RE'() {
        if (this.taponRadiador.RE) {
          this.taponRadiador.BE = false
        }
      },
      'taponRadiador.BE'() {
        if (this.taponRadiador.BE) {
          this.taponRadiador.RE = false
        }
      },
      'tarjetaCirc.RE'() {
        if (this.tarjetaCirc.RE) {
          this.tarjetaCirc.BE = false
        }
      },
      'tarjetaCirc.BE'() {
        if (this.tarjetaCirc.BE) {
          this.tarjetaCirc.RE = false
        }
      },
      'varillaAceite.RE'() {
        if (this.varillaAceite.RE) {
          this.varillaAceite.BE = false
        }
      },
      'varillaAceite.BE'() {
        if (this.varillaAceite.BE) {
          this.varillaAceite.RE = false
        }
      },
      'verificacion.RE'() {
        if (this.verificacion.RE) {
          this.verificacion.BE = false
        }
      },
      'verificacion.BE'() {
        if (this.verificacion.BE) {
          this.verificacion.RE = false
        }
      },
      'vestiduras.RE'() {
        if (this.vestiduras.RE) {
          this.vestiduras.BE = false
        }
      },
      'vestiduras.BE'() {
        if (this.vestiduras.BE) {
          this.vestiduras.RE = false
        }
      },
      'viceras.RE'() {
        if (this.viceras.RE) {
          this.viceras.BE = false
        }
      },
      'viceras.BE'() {
        if (this.viceras.BE) {
          this.viceras.RE = false
        }
      },
      
    },
    methods: {
      saveItems() {
        let myObj = {
          status: this.status,
          aseguradora: this.aseguradora,
          poliza: this.polizaSel.id,
          polizaStr: this.polizaSel.poliza,
          cobertura: this.cobertura,
          vencimiento: this.fechaVencimiento,
          observaciones: this.observaciones,
          antenaRadio: this.antenaRadio.BE ? 1 : this.antenaRadio.RE ? 2 : 0,
          batea: this.batea.BE ? 1 : this.batea.RE ? 2 : 0,
          bedliner: this.bedliner.BE ? 1 : this.bedliner.RE ? 2 : 0,
          birlos: this.birlos.BE ? 1 : this.birlos.RE ? 2 : 0,
          bolsa: this.bolsa.BE ? 1 : this.bolsa.RE ? 2 : 0,
          cablesCor: this.cablesCor.BE ? 1 : this.cablesCor.RE ? 2 : 0,
          calaveras: this.calaveras.BE ? 1 : this.calaveras.RE ? 2 : 0,
          cinturonesSeg: this.cinturonesSeg.BE ? 1 : this.cinturonesSeg.RE ? 2 : 0,
          controlApert: this.controlApert.BE ? 1 : this.controlApert.RE ? 2 : 0,
          cristales: this.cristales.BE ? 1 : this.cristales.RE ? 2 : 0,
          defensas: this.defensas.BE ? 1 : this.defensas.RE ? 2 : 0,
          emblemaD: this.emblemaD.BE ? 1 : this.emblemaD.RE ? 2 : 0,
          emblemaT: this.emblemaT.BE ? 1 : this.emblemaT.RE ? 2 : 0,
          encendedor: this.encendedor.BE ? 1 : this.encendedor.RE ? 2 : 0,
          espejoInt: this.espejoInt.BE ? 1 : this.espejoInt.RE ? 2 : 0,
          espejoLD: this.espejoLD.BE ? 1 : this.espejoLD.RE ? 2 : 0,
          espejoLI: this.espejoLI.BE ? 1 : this.espejoLI.RE ? 2 : 0,
          extintor: this.extintor.BE ? 1 : this.extintor.RE ? 2 : 0,
          faros: this.faros.BE ? 1 : this.faros.RE ? 2 : 0,
          hojalateria: this.hojalateria.BE ? 1 : this.hojalateria.RE ? 2 : 0,
          gato: this.gato.BE ? 1 : this.gato.RE ? 2 : 0,
          limpiadores: this.limpiadores.BE ? 1 : this.limpiadores.RE ? 2 : 0,
          llanta: this.llanta.BE ? 1 : this.llanta.RE ? 2 : 0,
          llantas: this.llantas.BE ? 1 : this.llantas.RE ? 2 : 0,
          llave: this.llave.BE ? 1 : this.llave.RE ? 2 : 0,
          llaveCruz: this.llaveCruz.BE ? 1 : this.llaveCruz.RE ? 2 : 0,
          llaveTaponComb: this.llaveTaponComb.BE ? 1 : this.llaveTaponComb.RE ? 2 : 0,
          manija: this.manija.BE ? 1 : this.manija.RE ? 2 : 0,
          manual: this.manual.BE ? 1 : this.manual.RE ? 2 : 0,
          medallon: this.medallon.BE ? 1 : this.medallon.RE ? 2 : 0,
          molduras: this.molduras.BE ? 1 : this.molduras.RE ? 2 : 0,
          motor: this.motor.BE ? 1 : this.motor.RE ? 2 : 0,
          parabrisas: this.parabrisas.BE ? 1 : this.parabrisas.RE ? 2 : 0,
          pintura: this.pintura.BE ? 1 : this.pintura.RE ? 2 : 0,
          placaD: this.placaD.BE ? 1 : this.placaD.RE ? 2 : 0,
          placaT: this.placaT.BE ? 1 : this.placaT.RE ? 2 : 0,
          polizaV: this.polizaV.BE ? 1 : this.polizaV.RE ? 2 : 0,
          portaPD: this.portaPD.BE ? 1 : this.portaPD.RE ? 2 : 0,
          portaPT: this.portaPT.BE ? 1 : this.portaPT.RE ? 2 : 0,
          radio: this.radio.BE ? 1 : this.radio.RE ? 2 : 0,
          reflejantes: this.reflejantes.BE ? 1 : this.reflejantes.RE ? 2 : 0,
          rines: this.rines.BE ? 1 : this.rines.RE ? 2 : 0,
          tapaCBatea: this.tapaCBatea.BE ? 1 : this.tapaCBatea.RE ? 2 : 0,
          tapetes: this.tapetes.BE ? 1 : this.tapetes.RE ? 2 : 0,
          taponAceite: this.taponAceite.BE ? 1 : this.taponAceite.RE ? 2 : 0,
          taponRueda: this.taponRueda.BE ? 1 : this.taponRueda.RE ? 2 : 0,
          taponGas: this.taponGas.BE ? 1 : this.taponGas.RE ? 2 : 0,
          taponRadiador: this.taponRadiador.BE ? 1 : this.taponRadiador.RE ? 2 : 0,
          tarjetaCirc: this.tarjetaCirc.BE ? 1 : this.tarjetaCirc.RE ? 2 : 0,
          varillaAceite: this.varillaAceite.BE ? 1 : this.varillaAceite.RE ? 2 : 0,
          verificacion: this.verificacion.BE ? 1 : this.verificacion.RE ? 2 : 0,
          vestiduras: this.vestiduras.BE ? 1 : this.vestiduras.RE ? 2 : 0,
          viceras: this.viceras.BE ? 1 : this.viceras.RE ? 2 : 0,
        }
        this.isDisabled = true
        this.itemsSelected = Object.assign({}, this.itemsSelected, myObj)
        this.$emit('itemsSelected_Vehiculo', myObj)
      },
      cancelAdd() {
        this.datosFaltantes = []
        this.isDisabled = false
        console.log('Cancelar')
        this.$emit('itemsSelected_Vehiculo','close')
      },
      convertBoolToInt(val) {
        let entero = 0
        if (val) {
          entero = 1
        } else {
          entero = 0
        }
        return entero
      }
    },
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/responsivas_Componentes/components/ListItems_Vehiculo.vue